var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99023 12C1.99023 6.49755 6.49755 1.99023 12 1.99023V3.2195C7.14145 3.2195 3.2195 7.14145 3.2195 12C3.2195 16.8585 7.14145 20.7219 12 20.7805C16.8585 20.7219 20.7219 16.8585 20.7805 12C20.7219 7.14145 16.8585 3.2195 12 3.2195V1.99023C17.5024 1.99023 22.0097 6.49755 22.0097 12C22.0097 17.5024 17.5024 22.0097 12 22.0097C6.49755 22.0097 1.99023 17.5024 1.99023 12Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9171 10.4195H13.5805V7.08293C13.5805 6.67318 13.2293 6.38049 12.761 6.38049H11.239C10.7707 6.38049 10.4195 6.67318 10.4195 7.08293V10.4195H7.08293C6.67318 10.4195 6.38049 10.7707 6.38049 11.239V12.761C6.38049 13.2293 6.67318 13.5805 7.08293 13.5805H10.4195V16.9171C10.4195 17.2683 10.7707 17.6195 11.239 17.6195H12.761C13.2293 17.6195 13.5805 17.2683 13.5805 16.9171V13.5805H16.9171C17.2683 13.5805 17.6195 13.2293 17.6195 12.761V11.239C17.6195 10.7707 17.2683 10.4195 16.9171 10.4195Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.b59429d9847e0e9c6774c8984267be65.svg";
export { ForwardRef as ReactComponent };